module.exports={
    "version": 9,
    "compilerVersion": "1.19.0+commit.72eaeba",
    "contract": "TxUtil",
    "md5": "c66a444a465b6393e97d6100739f5908",
    "structs": [
        {
            "name": "LockingScriptParts",
            "params": [
                {
                    "name": "code",
                    "type": "bytes"
                },
                {
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "OpPushData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "VarIntData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxInputProof",
            "params": [
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "txHash",
                    "type": "bytes"
                },
                {
                    "name": "outputIndexBytes",
                    "type": "bytes"
                },
                {
                    "name": "sequenceBytes",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxOutputProof",
            "params": [
                {
                    "name": "txHeader",
                    "type": "bytes"
                },
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "satoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "scriptHash",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        }
    ],
    "library": [
        {
            "name": "TxUtil",
            "params": [],
            "properties": [],
            "genericTypes": []
        }
    ],
    "alias": [],
    "abi": [
        {
            "type": "constructor",
            "params": []
        }
    ],
    "stateProps": [],
    "buildType": "debug",
    "file": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract/txUtil.scrypt",
    "hex": "",
    "sourceMapFile": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract-desc/txUtil.map.json"
}